<template>
  <MasterLayout>
    <div class="section__row mt-3" style="margin-bottom: 216px">
      <div>
        <b-modal
          ref="my-modal"
          id="modal1"
          hide-footer
          :title="$t('text.iFundWallet.confirmingPayment')"
          v-if="status == loading"
        >
          <div
            class="epump-loader"
            style="top: 22%; left: 35%; width: 120px; height: 120px"
          >
            <img src="@/assets/img/epump-logo.png" class="epump-loader-logo" />
          </div>
        </b-modal>
        <b-modal
          v-if="status == success"
          ref="my-modal"
          id="modal1"
          hide-footer
          :title="$t('text.iFundWallet.paymentConfirmed')"
        >
          <div style="margin: 0 auto; width: 43%; margin-top: 80px" class>
            <div class="success-checkmark">
              <div class="check-icon">
                <span class="icon-line line-tip"></span>
                <span class="icon-line line-long"></span>
                <div class="icon-circle"></div>
                <div class="icon-fix"></div>
              </div>
            </div>
          </div>
        </b-modal>
        <b-modal
          v-if="status == failure"
          ref="my-modal"
          id="modal1"
          hide-footer
          :title="$t('text.iFundWallet.errorConfirming')"
        >
          <div style="margin: 0 auto; width: 43%">
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 130.2 130.2"
              class="cancel_img"
            >
              <circle
                class="path circle"
                fill="none"
                stroke="#D06079"
                stroke-width="6"
                stroke-miterlimit="10"
                cx="65.1"
                cy="65.1"
                r="62.1"
              />
              <line
                class="path line"
                fill="none"
                stroke="#D06079"
                stroke-width="6"
                stroke-linecap="round"
                stroke-miterlimit="10"
                x1="34.4"
                y1="37.9"
                x2="95.8"
                y2="92.3"
              />
              <line
                class="path line"
                fill="none"
                stroke="#D06079"
                stroke-width="6"
                stroke-linecap="round"
                stroke-miterlimit="10"
                x1="95.8"
                y1="38"
                x2="34.4"
                y2="92.2"
              />
            </svg>
          </div>
        </b-modal>
      </div>
      <div class="center_div pb-5" style="margin-top: 0px">
        <div class="pad_div">
          <ul class="tabs__lists d-flex justify-content-center">
            <li class="mt-3" @click="changeTab('wallet')">
              <a
                href="#"
                class="tab_link"
                :class="[tab === 'wallet' ? 'active__tab__link' : null]"
              >
                <i
                  class="fa fa-credit-card mr-2"
                  aria-hidden="true"
                  :style="[tab === 'wallet' ? { color: '#370F70' } : null]"
                ></i>
                {{ $t("text.iFundWallet.bank") }}
              </a>
            </li>
            <li class="mt-3 ml-1" @click="changeTab('card')">
              <a
                href="#"
                class="tab_link"
                :class="[tab === 'card' ? 'active__tab__link' : null]"
              >
                <i
                  class="fa fa-credit-card mr-2"
                  aria-hidden="true"
                  :style="[tab === 'card' ? { color: '#370F70' } : null]"
                ></i>
                {{ $t("text.iFundWallet.fundWithCard") }}
              </a>
            </li>
          </ul>
        </div>
        <div v-if="tab === 'card'">
          <div class="pay_header text-center">
            {{ $t("text.iFundWallet.fundAccountWithCard") }}
          </div>
          <div class="text-center mt-4">
            <img src="@/assets/img/credit-card.svg" width="35px" />
          </div>
          <div class="text-center mt-4">
            <small class="small_text"></small>
          </div>
          <div class="input_holder">
            <div class="mt-4">
              <input type="hidden" class="email" />
              <input type="hidden" class="phone" />
              <input type="hidden" class="publicKey" />
              <input type="hidden" name="trxRef" class="trxRef" />
              <input type="hidden" name="flwRef" class="flwRef" />
              <input
                type="number"
                name="amount"
                class="form-control form__input amount"
                :placeholder="$t('text.iFundWallet.amount')"
                style="width: 100%"
              />
            </div>
          </div>
          <div class="mt-4 text-center">
            <button class="btn btn_theme" @click="payFunction($event)">
              {{ $t("text.iFundWallet.payNow") }}
            </button>
          </div>
        </div>

        <div v-if="tab === 'wallet'">
          <div class="pay_header text-center">Fund Account with your Bank</div>
          <div class="text-center mt-4">
            <img src="@/assets/img/money (3).svg" width="50" />
          </div>

          <!-- <div class="mx-auto text-center" style="width: 500px"> -->
          <div class="mx-auto text-center p-2">
            <ul class="mt-3 list-group">
              <li
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                {{ $t("text.iFundWallet.bankName") }}
                <span class="text-secondary">
                  {{ $t("text.iFundWallet.providusBank") }}</span
                >
              </li>
              <li
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                {{ $t("text.iFundWallet.accountNumber") }}
                <span class="text-secondary">{{ this.accountNumber }}</span>
              </li>
              <li
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span class="text-left">{{
                  $t("text.iFundWallet.accountName")
                }}</span>
                <!-- {{ $t("text.iFundWallet.accountName") }} -->
                <span class="text-secondary text-right">
                  {{ this.accountName }}</span
                >
              </li>
              <p class="font-weight-light mt-3">
                {{ $t("text.iFundWallet.clickContinue") }}
              </p>

              <router-link
                :to="{
                  name: 'IndustrialBranchDashboard',
                  query: {
                    branchId: this.$route.query.branchId,
                    companyId: this.$route.query.companyId,
                    groupId: this.$route.query.groupId,
                  },
                }"
                class="btn btn_theme mt-3"
              >
                {{ $t("text.iFundWallet.continue") }}
              </router-link>

              <!-- <button class="btn btn_theme mt-3" @click="maked">
                Continue
              </button> -->
            </ul>
          </div>
          <div class="fund_wallet_user_details_wrapper" style="width: 100%">
            <!-- <div class=" text-center input_holder">
                          <div class="mt-4">
                            <input
                              type="number"
                              name="amount"
                              class="form-control form__input amount"
                              :placeholder="$t('text.iFundWallet.amount')"
                              style="width: 100%"
                              v-model="fundingAmount"
                            />
                          </div>
                        </div> -->
            <div class="mt-5">
              <!-- <div class="pay_header text-center">Your Wallet would be funded within the next few minutes. </div> -->
            </div>
            <!-- <div class="mt-4 text-center">
                      <button class="btn btn_theme" @click="walletPayment($event)" 
                        :disabled="isButtonDisabled ? true : false"
                        :style="[
                          isButtonDisabled
                            ? { cursor: 'not-allowed' }
                            : { cursor: 'pointer' }
                        ]"> Continue
                        <img
                          src="@/assets/img/git_loader.gif"
                          style="display:none"
                          width="20px"
                          class="ml-3 loader"

                        />
                      </button>
                    </div> -->
          </div>
        </div>

        <div
          class="pattern_sec"
          :style="[
            {
              zIndex: '-1200',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundImage: `linear-gradient(rgb(55, 15, 112 , 0.001), rgb(55, 15, 112 ,0.001)), url(${backImg})`,
            },
          ]"
        ></div>
      </div>
    </div>
  </MasterLayout>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Industrial/MasterLayout.vue";
import configObject from "@/config";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import backgroundUrl from "@/assets/img/MobileWallet.png";
import TableLoader from "@/components/tableLoader/index";
import backImg from "@/assets/img/pattern_img.png";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Fund Wallet:: Epump Portal",
  props: ["corpId"],
  name: "VerifyReceipt",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      backImg,
      tab: "wallet",
      loading: 0,
      paymentConfirmed: null,
      success: 1,
      failure: 2,
      status: 0,
      backgroundUrl,
      modalWidth: null,
      modalheight: null,
      showBanner: true,
      payOnline: true,
      email: "",
      phone: "",
      publicKey: "",
      banks: null,
      amount: null,
      depositNo: null,
      depositorName: null,
      bank: null,
      showdropDown: false,

      accountNumber: null,
      toggleBanksDropdown: false,
      isButtonDisabled: false,
      showButtonLoader: true,
      flwRef: "",
      trxRef: "",
      reservedAccount: null,
      accountName: null,
      accountNumber: null,
      bankName: null,
      industryBranch: null,
      industryBranchId: null,
      fundingAmount: null,
    };
  },
  created() {
    this.$eventHub.$on("industryBranch", (industryBranch) => {
      this.industryBranch = industryBranch;
    });
  },
  beforeDestroy() {},
  mounted() {
    // this.showModal();
    // this.status = this.failure;
  },
  watch: {
    industryBranch: function (newIndustry, oldIndustry) {
      if (newIndustry.id !== null) {
        this.industryBranchId = newIndustry.id;
        this.getFundProperties();
        this.getAccountDetails();
      }
    },
  },
  methods: {
    changeTab(tab) {
      this.tab = tab;
    },
    // maked() {
    //   this.$router.push("/Industrial/Branch/Dashboard");
    // },
    randomString(length, chars) {
      var result = "";
      for (var i = length; i > 0; --i)
        result += chars[Math.floor(Math.random() * chars.length)];
      return result;
    },
    generateTransactionRef() {
      var allString = "0123456789";
      var rString = "EP" + this.randomString(14, allString);
      return rString;
    },
    walletPayment($event) {
      $event.preventDefault();
      if (!this.fundingAmount) {
        this.$toast.open({
          message: this.$t("text.iFundWallet.amountMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      let data = {
        branchId: this.industryBranchId,
        amount: parseFloat(this.fundingAmount),
        paymentMode: "UserWallet",
      };
      $(".loader").show();
      this.isButtonDisabled = true;
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Industrial/FundWallet`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.status = this.success;
          this.showModal();
          this.$toast.open({
            message: this.$t("text.iFundWallet.paymentConfirmed"),
            type: "success",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.status = this.failure;
          this.showModal();
          $(".loader").hide();
          this.isButtonDisabled = false;
        });
    },
    getFundProperties() {
      this.showBtnLoader = true;
      if (localStorage.getItem("userDetails")) {
        let url = `${configObject.apiBaseUrl}/Wallet/FundProperties`;
        this.axios
          .get(url, configObject.authConfig())
          .then((response) => {
            let user = JSON.parse(localStorage.getItem("userDetails"));
            this.showBtnLoader = false;
            this.email = user.email;
            this.phone = user.phone;
            this.publicKey = response.data.publicKey;
            this.referralCode = response.data.referralCode;
            this.banks = response.data.banks;
            // this.accountName = response.data.accountName;
            // this.bankName = response.data.bankName;
          })
          .catch((error) => {});
      }
    },
    // getAccountDetails() {
    //   this.showBtnLoader = true;
    //   if (localStorage.getItem("userDetails")) {
    //     let url = `${configObject.apiBaseUrl}/Wallet/Balance`;
    //     this.axios
    //       .get(url, configObject.authConfig())
    //       .then(response => {
    //         this.reservedAccount = response.data.reservedAccount;
    //         this.accountName = response.data.accountName;
    //         this.bankName = response.data.bankName;
    //       })
    //       .catch(error => {});
    //   }
    // },
    getAccountDetails() {
      this.showLoader = true;
      if (localStorage.getItem("userDetails")) {
        let url = `${configObject.apiBaseUrl}/Branch/branchremiswallet/${this.industryBranch.id}`;
        this.axios
          .get(url, configObject.authConfig())
          .then((res) => {
            // console.log(res.data.accountName)
            this.accountName = res.data.accountName;
            this.accountNumber = res.data.accountNumber;
            //this.banks = response.data.banks;
            //this.walletBalance = this.convertThousand(res.data.balance);
          })
          .catch((error) => {});
      }
    },
    showModal() {
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    confirmPayment() {
      this.showModal();
      this.status = this.loading;
      let data = {
        branchId: this.industryBranchId,
        amount: parseFloat(this.amount),
        paymentMode: "rave",
        trxRef: this.trxRef,
        flw: true,
        flwRef: this.flwRef,
      };
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Wallet/FundWalletOnline`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.status = this.success;
          // this.showModal();
          this.$toast.open({
            message: this.$t("text.iFundWallet.paymentConfirmed"),
            type: "success",
            duration: 5000,
          });
          this.routeToAdminDash();
        })
        .catch((error) => {
          this.status = this.failure;
        });
    },
    routeToAdminDash() {
      this.$router.push({
        name: "industrial_admin_dashboard",
        query: {
          branchId: this.$route.query.branchId,
          companyID: this.$route.query.companyID,
        },
      });
    },
    payFunction(event) {
      event.preventDefault();
      $(".email").val(this.email);
      $(".phone").val(this.phone);
      $(".publicKey").val(this.publicKey);
      var btn = $(this);
      btn.attr("disabled", "disabled");
      var realAmt = parseFloat($(".amount").val());
      if (isFinite(realAmt) && realAmt > 0) {
        //var amt = realAmt + (realAmt * (1.6 / 100));

        var email = $(".email").val();
        var phone = $(".phone").val();
        var pk = $(".publicKey").val(); //"FLWPUBK-fc08788826e348423d0d89eb1370f784-X";//
        var allString = "0123456789";
        var PBFKey = pk;
        var rString = "EP" + this.randomString(14, allString);
        let _this = this;
        // eslint-disable-next-line no-undef
        let raveSetup = getpaidSetup({
          PBFPubKey: PBFKey,
          customer_email: email,
          customer_firstname: "",
          customer_lastname: "",
          custom_description: "Fund Wallet",
          custom_logo:
            "https://app.epump.com.ng/Content_v3/Images/e-pump%20logo2.png",
          custom_title: "EPump",
          amount: realAmt,
          customer_phone: phone,
          country: "NG",
          currency: "NGN",
          payment_method: "both",
          txref: rString,
          //integrity_hash: "<ADD YOUR INTEGRITY HASH HERE>",

          callback: function (response) {
            // console.log("callback initiated");
            // console.log(response);
            var tx_Ref = response.tx.txRef;
            var flw_Ref = response.tx.flwRef;
            // collect flwRef returned and pass to a server page to complete status check.

            if (response.tx.chargeResponseCode == "00") {
              _this.trxRef = tx_Ref;
              _this.flwRef = flw_Ref;
              _this.amount = realAmt.toString();
              //_this.closeModal();
              _this.confirmPayment();
              // $('.trxRef').val(response.tx.txRef);
              // $('.flwRef').val(flw_ref);
              //$('.onlinePay').submit();

              // redirect to a success page
            } else {
              // redirect to a failure page.
            }
            raveSetup.close();
          },
          onclose: function () {
            btn.removeAttr("disabled");
          },
        });
      } else {
        this.$toast.open({
          message: this.$t("text.iFundWallet.amountMissing"),
          type: "error",
          duration: 10000,
        });
        btn.removeAttr("disabled");
      }
    },
  },
};
</script>
